<template>
  <h1>Tickets</h1>
  <div class="tix">
    <p>
      Tickets for ’12 ANGRY JURORS’ are available beginning November 8th by
      calling 315-218-4002 during school hours, going online to
      <a class="tix-link" href="https://www.showtix4u.com/event-details/57899">
        https://www.showtix4u.com/event-details/57899</a
      >, and will also be sold at the door. Doors will open at 6:30pm and masks
      are required at all times regardless of vaccination status. All tickets
      are reserved, $12 for students/seniors and $14 for adults. For more
      information, please follow us on Instagram: @cnsguild.
    </p>
    <div>
      <img alt="Tickets" src="../assets/Tickets-Logo.jpg" />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.tix {
  display: grid;
  grid-template-columns: 3fr 1fr;
  margin: 0 15vw;
  column-gap: 2rem;
}

.tix-link {
  color: white;
}

.tix img {
  width: 100%;
}

@media (max-width: 850px) {
  .tix {
    grid-template-columns: 1fr;
    margin: 0 1rem;
  }

  .tix .write-up {
    padding: 0;
  }

  p {
    font-size: 1rem;
  }
}
</style>
